module.exports = __webpack_public_path__ + "img/feedback.73be7956.svg";